import ListHeader from 'components/assets/AssetsListHeader';
import Table from 'components/assets/AssetsTable';
import AddView from 'components/assets/AssetsAddView';
import List from 'components/assets/AssetsList';
import Row from 'components/assets/AssetsRow';
import Form from 'components/assets/AssetsForm';
import Edit from 'components/assets/edit';
import DisableView from 'components/assets/AssetsDisableView';

export default {
  ListHeader,
  Table,
  AddView,
  Edit,
  List,
  Row,
  Form,
  DisableView,
};



// WEBPACK FOOTER //
// src/components/assets/index.js